// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip__y1CCe","disabled":"disabled__1ngpF"};